import {BooleanField, Datagrid, DateField, FunctionField, Link, NumberField, TextField} from "react-admin";
import {DatagridPropsWithOptions} from "../../shared/types";
import {initField} from "../../shared/utils";
import {IdentifierField} from "../../components/IdentifierField";
import {linkToRecord, Record} from "ra-core";
import {Chip} from "@material-ui/core";
import {ChangeStatusReceiptButton} from "./ChangeStatusReceiptButton";


interface Props extends DatagridPropsWithOptions{
    type: any;
}



export const BankReceiptDatagrid = ({
                                        options,
                                        type,
                                        ...rest
                                    }: Props) => {

    return options && (
        <Datagrid {...rest}>
            <IdentifierField show {...initField("id", options)} />
            <FunctionField label="Stato"
                           render={function (record?: Record | undefined, source?: string) {
                               if (!record) return
                               if (record.receipt_status === "CR") {
                                   return <ChangeStatusReceiptButton edit={false}/>
                               } else if (record.receipt_status === "US") {
                                   return <><ChangeStatusReceiptButton edit={true}/><Chip color="primary" size="small" variant="outlined" label="Insoluta"/></>
                               }  else if (record.receipt_status === "RE") {
                                   return <><ChangeStatusReceiptButton edit={true}/><Chip color="primary" size="small" variant="outlined" label="Stornata"/></>
                               } else {
                                   return <><ChangeStatusReceiptButton edit={true}/><Chip style={{color: "green"}} size="small" variant="outlined"
                                                label={record.payment_schedule.invoice.invoice_type === "S" ? "Incassata" : "Pagata"}/></>
                               }
                           }}
            />
            {
                type === "S" ?  <FunctionField
                    render={function (record?: Record | undefined, source?: string) {
                        return (record && record.payment_schedule) && (
                            <Link to={`/invoices/${record.payment_schedule.invoice.id}/show`}>
                                {`${record.payment_schedule.invoice.id}: ${record.payment_schedule.invoice.type}-${record.payment_schedule.invoice.sequence_number }`}
                            </Link>
                        )
                    }}
                    label="Fattura"
                    sortBy="payment_schedule__invoice__sequence_number"
                /> : <FunctionField
                    render={function (record?: Record | undefined, source?: string) {
                        return (record && record.payment_schedule) && (
                            <Link to={`/invoices/${record.payment_schedule.invoice.id}/show`}>
                                {`${record.payment_schedule.invoice.id}: ${record.payment_schedule.invoice.type}-${record.payment_schedule.invoice.invoice_number}`}
                            </Link>
                        )
                    }}
                    label="Fattura"
                    sortBy="payment_schedule__invoice__invoice_number"
                />
            }

            <FunctionField
                label="Azienda"
                source="company_object"
                render={(record: Record | undefined) => {
                    if (record && record.payment_schedule.invoice.company_object) {
                        return (
                            <Link
                                to={linkToRecord("/subjects", record.payment_schedule.invoice.company_object.company.id, "edit")}>
                                <TextField
                                    record={record.payment_schedule.invoice.company_object}
                                    source="name"
                                    variant="inherit"

                                />
                            </Link>
                        );
                    }
                    return null;
                }}
                sortBy="company__company__business_name"
            />
            {
                type === "S" ? <FunctionField
                    label="Cliente"
                    source="client_id"
                    render={(record: Record | undefined) => {
                        if (record) {
                            return (
                                <Link to={linkToRecord("/subjects", record.payment_schedule.invoice.client_id, "edit")}>
                                    <TextField
                                        record={record.payment_schedule.invoice.client}
                                        source="business_name"
                                        variant="inherit"
                                    />
                                </Link>
                            );
                        }
                        return null;
                    }}
                    sortBy="payment_schedule__invoice__client__business_name"
                /> : <FunctionField
                    label="Fornitore"
                    source="supplier_id"
                    render={(record: Record | undefined) => {
                        if (record) {
                            return (
                                <Link to={linkToRecord("/subjects", record.payment_schedule.invoice.client_id, "edit")}>
                                    <TextField
                                        record={record.payment_schedule.invoice.client}
                                        source="business_name"
                                        variant="inherit"
                                    />
                                </Link>
                            );
                        }
                        return null;
                    }}
                    sortBy="payment_schedule__invoice__supplier__business_name"
                />
            }

            {type === "S" && <BooleanField
                {...initField("loaded", options)} label="Caricata"
            />}
            {type === "S" && <BooleanField
                {...initField("generated", options)} label="Generata"
            />}
            <DateField {...initField("payment_schedule.invoice.invoice_date", options)} label="Data fattura" sortBy={"payment_schedule__invoice__invoice_date"}/>
            <DateField {...initField("expiration_date", options)} label="Data scadenza"/>
            <NumberField {...initField("payment_schedule.amount", options)} label="Importo" sortBy="payment_schedule__amount"  options={{ style: 'currency', currency: 'EUR' }} />
        </Datagrid>
    );
};
